module.exports = "/images/reset.svg?25514fc4db1a4ce8c918ee5f0152352a";